module.exports = __webpack_public_path__ + "static/media/Anatomy_Bad.fda222c4.png";